<template>
<el-row class="detail-top border-radius5">
  <el-col :lg="12" :md="12" :sm="12" :xs="24">
    <el-carousel
      :height="carouselHeight"
      class="detail-top-carousel-el"
    >
      <el-carousel-item
        v-for="(item,index) in productDetail.slideImgs"
        :key="index"
        class="carousel-item-el"
      >
        <img
          class="carousel-image"
          :src="item"
          alt=""
        >
      </el-carousel-item>
    </el-carousel>
  </el-col>
  <el-col :lg="12" :md="12" :sm="12" :xs="24">
    <div class="text-box">
      <div class="header-box">
        <div
          v-if="productDetail.isTop"
          class="product-tag stick"
        >
          {{$t('Sticky')}}
        </div>
        <div
          v-if="productDetail.tagName"
          class="product-tag recommend">
          {{productDetail.tagName}}
        </div>
        <span class="title">{{productDetail.productName}}</span>
      </div>
      <p class="intro">{{productDetail.intro}}</p>
      <div class="data-line display-flex flex-start">
        <div class="integral-left">
          <img
            class="detail-icon-box"
            width="18px"
            src="../../../assets/images/userCenter/integral.png"
            alt=""
          >
          <span class="integral-number">{{nowIntegral}}</span>
          <span
            v-if="productDetail.preferentialPrice"
            class="original-price"
          >{{productDetail.originalPrice}}</span>
        </div>
        <el-divider direction="vertical"></el-divider>
        <div class="sales">{{$t('Sales')}} {{productDetail.sales}}</div>
      </div>
      <div class="do-line">
        <div class="data-right">
          <div
            @click="subHandle"
            class="sub-btn btn up-down-left-right-center">
            <span>-</span>
          </div>
          <span class="item-num">{{num}}</span>
          <div
            @click="addHandle"
            class="add-btn btn up-down-left-right-center">
            <span>+</span>
          </div>
        </div>
        <el-button
          :loading="addLoading"
          @click="addCarHandle"
         size="large"
         type="primary"
        >{{$t('add_to_the_cart')}}</el-button>
      </div>
    </div>
  </el-col>
</el-row>
</template>

<script>
import { addProductToCar } from '@/api/userCenter'
export default {
  name: 'detailTop',
  props: {
    productDetail: {
      type: Object,
      default(){
        return {

        }
      }
    }
  },
  data() {
    return {
      num: 1,
      addLoading: false,
    };
  },
  computed: {
    carouselHeight(){
      return '300px'
    },
    nowIntegral() {
      if(this.productDetail.preferentialPrice){
        return this.productDetail.preferentialPrice;
      }else {
        return this.productDetail.originalPrice;
      }
    }
  },
  methods: {
    subHandle() {
      if(this.num === 0) return;
      this.num--;
    },
    addHandle(){
      this.num++;
    },
    addCarHandle(){
      // 添加到购物车 ajax
      this.addLoading = true;
      addProductToCar({
        productId: this.$route.params.id,
        quantity: this.num,
      }).then((res) => {
        if(res&&res.code&&res.code == 200){
          this.$message({
            message: '操作成功',
            type: 'success',
            duration: 2000,
          });
          this.$emit('addcar-success');
          setTimeout(() => {
            this.addLoading = false;
          },1000)
        }else{
          this.$message.error(res.msg);
        }
      })
    }
  }
};
</script>

<style lang="scss" scoped>
@import "../../../assets/scss/variable";

.detail-top {
  background-color: #ffffff;
  .detail-top-carousel-el {
    .carousel-item-el {
      text-align: center;
    }
    .carousel-image {
      max-height: 300px;
    }
  }

  .text-box {
    padding-left: 20px;
    padding-right: 20px;
  }
  .header-box {
    display: flex;
    justify-content: flex-start;
    align-items: center;
    margin-bottom: 10px;
    .product-tag {
      border-radius: 2px;
      color: #ffffff;
      font-size: 14px;
      display: inline-block;
      padding: 2px;
      margin-right: 5px;
      &.stick {
        background-color: $themeColor;
      }
      &.recommend {
        background-color: $themeGreen;
      }
    }
    .title {
      font-weight: 600;
      color: #333333;
      font-size: 20px;
    }
  }
  .intro {
    font-size: 14px;
    color: #999999;
    margin-bottom: 10px;
  }
  .data-line {
    font-size:14px;
    .integral-number {
      color: $themeColor  ;
    }
    .sales,
    .original-price {
      color: #999999;
    }
    .original-price {
      text-decoration: line-through;
    }
    .integral-left {
      display: flex;
      justify-content: flex-start;
      align-items: center;
      .integral-number {
        margin: 0 5px;
      }
    }
  }
  .do-line {
    display: flex;
    justify-content: flex-start;
    align-items: center;
    margin-top: 30px;
    .data-right {
      display: flex;
      justify-content: flex-start;
      align-items: center;
      margin-right: 20px;
      .item-num {
        margin: 0 5px;
      }
      .btn {
        width: 20px;
        height: 20px;
        border: 1px solid #333333;
        font-size: 16px;
        cursor: pointer;
        &.add-btn {
          background-color: #333333;
          color: #ffffff;
        }
      }
    }
  }
}
@media screen and (min-width: 768px) {
  .detail-top .text-box {
    padding-top: 60px;
  }
}
@media screen and (max-width: 768px) {
  .detail-top .text-box {
    padding-top: 30px;
    padding-bottom: 30px;
  }
}
</style>
<style lang="scss">
@import "../../../assets/scss/variable";
.detail-top {
  .el-carousel__indicator {
    .el-carousel__button {
      width: 10px;
      height: 10px;
      background-color: #E6E6E6;
      border-radius: 50%;
    }
    &.is-active .el-carousel__button {
      background-color: $themeColor;
    }
  }
  .el-carousel__arrow {
    background-color: rgba(0,0,0, 0.6);
  }
}

</style>
